const pagination = {
  data: function() {
    return {
      sortBy: "id",
      sortDesc: false,
      serverItemsLength: 0,
      options: {}
    };
  },
  methods: {
    fetchData(options) {
      throw "Implementar";
    },
    fillPaginationFromResponse(response) {
      this.serverItemsLength = response.meta.total;
    },
    getPaginationParams(options = {}) {
      return {
        page: options.page || 1,
        per_page: options.itemsPerPage || 10,
        sort_by: !!options.sortBy ? options.sortBy[0] : this.sortBy,
        sort_desc: !!options.sortDesc ? options.sortDesc[0] : this.sortDesc
      };
    }
  },
  computed: {
    paginationProps() {
      return {
        serverItemsLength: this.serverItemsLength
      };
    }
  },
  watch: {
    options: {
      handler(options) {
        this.fetchData(options);
      },
      deep: true
    }
  }
};

export default pagination;
